import React from "react";
import { clsx } from "clsx";

import { useAllSaasDestinations } from "@/hooks/useAllSaasDestinations";
import { SaaSDestinationSlug } from "@/destinations/types";

export type LogoBrand = SaaSDestinationSlug;

interface LogoProps {
  className?: string;
  brand: LogoBrand;
}

export function Logo({ className, brand }: LogoProps) {
  const saasDestinations = useAllSaasDestinations();
  const BrandComponent = saasDestinations[brand]?.logoSquare;

  if (!BrandComponent) {
    console.warn(`No logo found for brand: ${brand}`);
    return null;
  }

  return (
    <div
      className={clsx(
        className,
        "flex items-center justify-center *:h-full *:w-full",
      )}
    >
      <BrandComponent />
    </div>
  );
}
